import { connect, useDispatch } from "react-redux";

import { getDisplayName } from "../Utils/getDisplayName";
import { showAlert, hideAlert } from "../../reducers/alerts";

export default function withAlert(WrappedComponent) {
  const WithAlert = props => <WrappedComponent {...props} />;

  WithAlert.displayName = `WithAlert(${getDisplayName(WrappedComponent)})`;

  const dispatchShowAlert = (dispatch, alert) => {
    const action = showAlert(alert);
    dispatch(action);
    return action.alertKey;
  };

  const mapDispatchToProps = dispatch => {
    return {
      showAlert: alert => dispatchShowAlert(dispatch, alert),
      hideAlert: alertKey => dispatch(hideAlert(alertKey))
    };
  };

  return connect(null, mapDispatchToProps)(WithAlert);
}

export const useAlert = () => {
  const dispatch = useDispatch();

  return {
    showAlert: alert => dispatch(showAlert(alert)),
    hideAlert: () => dispatch(hideAlert())
  };
};
